export default class BackofficeDocumentationsDatabaseMcd {
  constructor() {
    this.init();
  }

  init() {
    const sourceElement = document.getElementById('database-mcd-markdown-source');
    const renderedElement = document.getElementById('database-mcd-rendered');
    const autoRefreshStorageKey = 'database_mcd_auto_refreshed_once';

    const autoRefreshTimeout = window.setTimeout(function() {
      if (!renderedElement) {
        return;
      }

      const hasRenderedContent = renderedElement.textContent.trim().length > 0;
      const alreadyRefreshed = sessionStorage.getItem(autoRefreshStorageKey) === '1';

      if (!hasRenderedContent && !alreadyRefreshed) {
        sessionStorage.setItem(autoRefreshStorageKey, '1');
        window.location.reload();
      }
    }, 3000);

    if (!sourceElement || !renderedElement) {
      return;
    }

    const markdown = sourceElement.textContent || '';
    const renderer = new marked.Renderer();

    try {
      renderer.code = function(code, language) {
        if (language === 'mermaid') {
          return '<div class="mermaid">' + code + '</div>';
        }

        const escapedCode = code
          .replaceAll('&', '&amp;')
          .replaceAll('<', '&lt;')
          .replaceAll('>', '&gt;');

        return '<pre><code>' + escapedCode + '</code></pre>';
      };
      marked.setOptions({ renderer: renderer, gfm: true, breaks: true });

      const rawHtml = marked.parse(markdown);
      renderedElement.innerHTML = DOMPurify.sanitize(rawHtml, {
        ADD_TAGS: ['iframe'],
        ADD_ATTR: ['allow', 'allowfullscreen', 'frameborder', 'scrolling']
      });

      mermaid.initialize({ startOnLoad: false, theme: 'default' });
      mermaid.run({ querySelector: '#database-mcd-rendered .mermaid' });

      if (renderedElement.textContent.trim().length > 0) {
        sessionStorage.removeItem(autoRefreshStorageKey);
      }
    } catch (error) {
      console.error('Failed to render database MCD markdown', error);
    }
  }
}